/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileProxyActionType } from '../models/ApiProfileProxyActionType';
import { HttpFile } from '../http/http';

export class ApiCreateNewProfileProxyCreateWaveAction {
    'action_type': ApiProfileProxyActionType;
    'end_time': number | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "action_type",
            "baseName": "action_type",
            "type": "ApiProfileProxyActionType",
            "format": ""
        },
        {
            "name": "end_time",
            "baseName": "end_time",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateNewProfileProxyCreateWaveAction.attributeTypeMap;
    }

    public constructor() {
    }
}


